import { Outlet } from "react-router";

import { useOrgSelection } from "@/context/use-org-selection";

/**
 * Layout route for pages that act on the selected organization. Renders the
 * page only once an organization is selected, and keeps "no organizations
 * assigned" distinguishable from "we could not load them". Conflating the two
 * tells a fully-provisioned admin their access record is missing and sends
 * them to chase a request that was never needed.
 */
export const OrganizationGate = () => {
	const { error, isLoading, organizations } = useOrgSelection();

	if (isLoading) {
		return <p className="text-secondary text-sm">Loading organizations…</p>;
	}

	if (error) {
		return (
			<p className="text-error-primary text-sm">
				Could not load your organizations. {error.message}
			</p>
		);
	}

	if (organizations.length === 0) {
		return (
			<p className="text-secondary text-sm">
				No organizations have been assigned to your account yet. Ask an
				administrator to add them to your ShadowAccess record.
			</p>
		);
	}

	return <Outlet />;
};
